import { Routes, Route } from 'react-router-dom';
import { Layout, MarkdownPage } from '@mojo/static-site-ui';
import navigation from './generated/navigation.json';
import type { NavigationData } from '@mojo/static-site-ui';

const navData = navigation as NavigationData;
const DEPLOYED_URL = 'https://framework.heatherstone.com';

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout
            siteName="Command Architecture"
            navigation={navData}
            deployedUrl={DEPLOYED_URL}
            enableSearch
          >
            <MarkdownPage navigation={navData} showRecentChanges={false} />
          </Layout>
        }
      />
      <Route
        path="*"
        element={
          <Layout
            siteName="Command Architecture"
            navigation={navData}
            deployedUrl={DEPLOYED_URL}
            enableSearch
          >
            <MarkdownPage navigation={navData} showRecentChanges={false} />
          </Layout>
        }
      />
    </Routes>
  );
}

export default App;
